import Api from '../Base'

class PatchSpaceInstance extends Api {
  requestUrl = `/api/SpaceInstance/${this.getParams().id}`

  method = 'PATCH'
}

export default PatchSpaceInstance
